export const TESTIMONIAL_INNER_CONTAINER_ONE =
    "max-w-full md:max-w-[60%]  mx-2 md:mx-auto ";
export const TESTIMONIAL_INNER_CONTAINER_TWO =
    " new-home-slick-dot max-w-full lg:max-w-[80%] mx-auto ";
export const TESTIMONIAL_BUTTON_CONTAINER = " flex mt-[47px] sm:mt-[72px] ";
export const IMAGE_CONTAINER_CLASS = " px-1 sm:px-2 ";
export const CUSTOM_PRIMARY_BUTTON_CLASS = " !px-2 !gap-1 xs:!px-6 xs:!gap-2 ";
